import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'
import tokens from '@gympass/yoga-tokens'

import SMBImage from '@components/Image'
import { H3, Paragraph, H6 } from '@components/Text'

import { Button as YogaButton } from '@gympass/yoga'

export const Main = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 48px;
  padding-bottom: 32px;
  height: calc(100vh - 379px);

  a {
    color: ${tokens.colors.vibin};
    font-weight: 500;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    height: calc(100vh - 281px);
  }

  @media (max-width: ${getBreakpoint('sm')}px) {
    height: calc(100vh - 120px);
    margin-bottom: 40px;
  }

  @media (max-width: ${getBreakpoint('xs')}px) {
    height: calc(100vh - 60px);
    margin-bottom: 80px;
    font-size: 18px;
  }
`

export const Title = styled(H3)`
  font-weight: 500;
  line-height: 42px;
`

export const Subtitle = styled(Paragraph)`
  font-weight: 400;
  line-height: 28px;
  margin-top: 16px;
  color: ${tokens.colors.deep};

  a {
    text-decoration: none;
  }
`

export const ButtonWrapper = styled.section`
  margin-top: 32px;
`

export const Image = styled(SMBImage)`
  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: -32px;
    margin-left: 180px;
  }

  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: -32px;
    margin-left: 67px;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 500;
`
export const Button = styled(YogaButton)`
  @media (max-width: ${getBreakpoint('sm')}px) {
    width: 100%;
  }
`
